import { render, staticRenderFns } from "./SidebarActions.vue?vue&type=template&id=c11e15e8&scoped=true"
import script from "./SidebarActions.vue?vue&type=script&lang=js"
export * from "./SidebarActions.vue?vue&type=script&lang=js"
import style0 from "./SidebarActions.vue?vue&type=style&index=0&id=c11e15e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11e15e8",
  null
  
)

export default component.exports